import { render, staticRenderFns } from "./ServiceTitle.vue?vue&type=template&id=bcb53d60&scoped=true&lang=pug"
import script from "./ServiceTitle.vue?vue&type=script&lang=ts"
export * from "./ServiceTitle.vue?vue&type=script&lang=ts"
import style0 from "./ServiceTitle.vue?vue&type=style&index=0&id=bcb53d60&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb53d60",
  null
  
)

export default component.exports